import { I18n } from '@calendly/i18n';
import { Icon } from '@calendly/ui/components/icon';
import { Modal } from '@calendly/ui/components/modal';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import { colorTextInverseStandard } from '@calendly/ui/theme';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { OneOffContent } from '../one_off_content';
import { PollContent } from '../poll_content';
import { eventTypeSelector, isPollSelector, modalVisibleSelector } from '../selectors';
import { closeModal } from '../slice';
import { CopyButton } from './copy_button';
import { CopyLinkField } from './copy_link_field';
import { Body, BodyContent, CloseButton, CloseIconButton, FlexWrapper, Footer, Header, LogoBlock, ModalContent } from './styles';
import { ViewPageLink } from './view_page_link';
const linkLogoBlockIsPhoneCss = "limckpw";
const linkLogoBlockCss = "l1ttevqk";
const LinkLogoBlock = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <LogoBlock ref={ref} {...props} className={classNames(linkLogoBlockCss, {
    [linkLogoBlockIsPhoneCss]: isPhone
  }, props.className)}>
      <Icon name="link-bold" />
    </LogoBlock>;
});
export const OneOffShareModal = ({
  onClose: onCloseCallback = () => {}
}) => {
  const isPhone = useDeviceType('isPhone');
  const dispatch = useDispatch();
  const isPoll = useSelector(isPollSelector);
  const modalVisible = useSelector(modalVisibleSelector);
  const {
    bookingUrl,
    bookingMethod
  } = useSelector(eventTypeSelector);
  const title = isPoll ? I18n.t('publisher.event_types.one_off_share_modal.poll.title') : I18n.t('publisher.event_types.one_off_share_modal.one_off.title');
  const description = isPoll ? I18n.t('publisher.event_types.one_off_share_modal.poll.description') : I18n.t('publisher.event_types.one_off_share_modal.one_off.description');
  const onClose = () => {
    dispatch(closeModal());
    onCloseCallback();
  };
  return <Modal isOpen={modalVisible} onClose={onClose}>
      <ModalContent>
        <Header isPoll={isPoll}>
          <CloseIconButton onClick={onClose} />
          <FlexWrapper>
            <LinkLogoBlock />
            <div>
              <TitleText size="large" level={2} color={colorTextInverseStandard}>{title}</TitleText>
              <BodyText size="medium" color={colorTextInverseStandard}>{description}</BodyText>
            </div>
          </FlexWrapper>
          <CopyLinkField />
          <ViewPageLink bookingUrl={bookingUrl} bookingMethod={bookingMethod} />
        </Header>
        <Body>
          <BodyContent>
            {isPoll ? <PollContent /> : <OneOffContent />}
          </BodyContent>
        </Body>
        {isPhone && <Footer>
            <CloseButton onClick={onClose} />
            <CopyButton />
          </Footer>}
      </ModalContent>
    </Modal>;
};
OneOffShareModal.propTypes = {
  onClose: PropTypes.func
};

require("./share_modal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./share_modal.js");